module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: [{
      'rolled-out': _vm.isRolledOut
    }],
    attrs: {
      "id": "chat-layout"
    },
    on: {
      "mousemove": _vm.clearTitle
    }
  }, [(!_vm.fetchingLoginStatus && _vm.isLoggedIn) ? [_c('chat-side-panel'), _vm._v(" "), _c('chat-panel'), _vm._v(" "), _c('active-chats-panel')] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25850e0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/ChatLayout.vue
// module id = 393
// module chunks = 1